import $ from "jquery"

$('.js-challenge-sidebar').each(function(){
    $(this).on('click', function(){
        $('.js-challenge-sidebar').removeClass('active');
        $(this).addClass('active');

        $('.js-challenge-full').html($(this).find('.js-challenge-html').html());
    });
});